import { reportCorporateShipmentsTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_CORPORATE_SHIPMENTS, SET_REPORT_CORPORATE_SHIPMENTS_FILTERS } = reportCorporateShipmentsTypes;

const initialState = {
  ReportCorporateShipments: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportCorporateShipmentsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_CORPORATE_SHIPMENTS:
      return { ...state, ReportCorporateShipments: payload };
    case SET_REPORT_CORPORATE_SHIPMENTS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    default:
      return state;
  }
};
